export default {
  SET_LIST(state, data) {
    state.suppliers = data;
  },
};
